export class MesAno {
	public readonly start: Date;
	public readonly end: Date;

	constructor(
		public readonly month: number,
		public readonly year: number,
	) {
		this.start = new Date(year, month - 1, 1);
		this.end = new Date(year, month, 0);
	}
}
